import * as showroomAppointmentsActions from '../actions/showroomAppointments'

import {ApiRequestStates} from '../const'

const initialState = {
  appointment: {},
  cancelApptStatus: ApiRequestStates.IDLE,
  formData: {},
  getApptStatus: ApiRequestStates.IDLE,
}

const showroomAppointmentScheduleReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case showroomAppointmentsActions.CANCEL_APPOINTMENT:
      return {
        ...state,
        cancelApptStatus: ApiRequestStates.PENDING,
      }

    case showroomAppointmentsActions.CANCEL_APPOINTMENT_PENDING:
      return {
        ...state,
        cancelApptStatus: ApiRequestStates.PENDING,
      }

    case showroomAppointmentsActions.CANCEL_APPOINTMENT_SUCCESS: {
      return {
        ...state,
        cancelApptStatus: ApiRequestStates.SUCCESS,
      }
    }

    case showroomAppointmentsActions.CANCEL_APPOINTMENT_FAILURE:
      return {
        ...state,
        cancelApptStatus: ApiRequestStates.ERROR,
      }

    case showroomAppointmentsActions.GET_APPOINTMENT:
      return {
        ...state,
        getApptStatus: ApiRequestStates.PENDING,
        appointment: {},
      }

    case showroomAppointmentsActions.GET_APPOINTMENT_PENDING:
      return {
        ...state,
        getApptStatus: ApiRequestStates.PENDING,
        appointment: {},
      }

    case showroomAppointmentsActions.GET_APPOINTMENT_SUCCESS: {
      return {
        ...state,
        getApptStatus: ApiRequestStates.SUCCESS,
        appointment: action.payload.appointment,
      }
    }

    case showroomAppointmentsActions.GET_APPOINTMENT_FAILURE:
      return {
        ...state,
        getApptStatus: ApiRequestStates.ERROR,
        appointment: {},
      }

    case showroomAppointmentsActions.SELECT_TIMESLOT:
      return {
        ...state,
        selectedTimeSlot: action.selectedTimeSlot,
        error: undefined,
      }

    case showroomAppointmentsActions.STORE_SELECTED_SHOWROOM:
      return {
        ...state,
        showroom: action.showroom,
      }

    case showroomAppointmentsActions.TOGGLE_EVENT_DATE_PICKER:
      return {
        ...state,
        eventDatePickerVisible: !state.eventDatePickerVisible,
      }

    case showroomAppointmentsActions.UPDATE_SELECTED_DATE:
      return {
        ...state,
        appointmentDate: action.selectedDate,
      }

    case showroomAppointmentsActions.CREATE_APPOINTMENT:
      return {
        ...state,
        error: undefined,
        formData: initialState.formData,
        isPosting: true,
      }

    case showroomAppointmentsActions.CREATE_APPOINTMENT_PENDING:
      return {
        ...state,
        isPosting: true,
      }

    case showroomAppointmentsActions.CREATE_APPOINTMENT_SUCCESS:
      return {
        ...state,
        formData: {...action.payload.fields},
        isPosting: false,
      }

    case showroomAppointmentsActions.CREATE_APPOINTMENT_FAILURE:
      return {
        ...state,
        error: action,
        isPosting: false,
      }

    case showroomAppointmentsActions.GET_SHOWROOM_APPOINTMENT_SCHEDULE:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      }

    case showroomAppointmentsActions.GET_SHOWROOM_APPOINTMENT_SCHEDULE_PENDING:
      return {
        ...state,
        ...action.payload,
        isFetching: true,
      }

    case showroomAppointmentsActions.GET_SHOWROOM_APPOINTMENT_SCHEDULE_FAILURE:
      return {
        ...state,
        error: action,
        isFetching: false,
      }

    case showroomAppointmentsActions.GET_SHOWROOM_APPOINTMENT_SCHEDULE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isFetching: false,
      }

    case showroomAppointmentsActions.GET_SHOWROOM_OPEN_TIMES_FAILURE:
      return {
        ...state,
        error: action,
        isFetching: false,
      }

    case showroomAppointmentsActions.GET_SHOWROOM_OPEN_TIMES_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isFetching: false,
      }

    case showroomAppointmentsActions.GET_SHOWROOM_OPEN_TIMES_PENDING:
      return {
        ...state,
        ...action.payload,
        isFetching: true,
      }

    case showroomAppointmentsActions.CLEAR_SHOWROOM_APPOINTMENT_SERVICES:
      return {
        ...state,
        services: [],
        error: undefined,
        isFetching: false,
      }

    case showroomAppointmentsActions.GET_SHOWROOM_APPOINTMENT_SERVICES:
      return {
        ...state,
        error: undefined,
        isFetching: true,
      }

    case showroomAppointmentsActions.GET_SHOWROOM_APPOINTMENT_SERVICES_SUCCESS:
      return {
        ...state,
        ...action.payload,
        isFetching: false,
      }

    case showroomAppointmentsActions.GET_SHOWROOM_APPOINTMENT_SERVICES_FAILURE:
      return {
        ...state,
        error: action,
        isFetching: false,
      }

    default:
      return state
  }
}

export default showroomAppointmentScheduleReducer
